import { GenerationFailed } from './GenerationFailed'
export default GenerationFailed
